import { ErrorBoundary } from "react-error-boundary";

import { ClipOfTheDay } from "../ClipOfTheDay";
import { ReferralAnnouncement } from "../ReferralAnnouncement";
import { HomepageWrapper } from "../styledComponents";
import { ActivityFeed } from "./ActivityFeed";
import { FriendsLeaderboardWidget } from "./Widgets/FriendsLeaderboardWidget";
import { RecentCompetitionWidget } from "./Widgets/RecentCompetitionWidget";
// import { PerformanceWidget } from "./Widgets/PerformanceWidget";
import { TrendingNowWidget } from "./Widgets/TrendingNowWidget";
import { WhoToFollowWidget } from "./Widgets/WhoToFollowWidget";
import {
  CappedContent,
  FeedAside,
  FeedColumns,
  FeedMain,
  HomepageContainer,
} from "./styledComponents";

export const ActivityFeedHome = () => (
  <HomepageWrapper>
    <HomepageContainer>
      <ClipOfTheDay announcement={<ReferralAnnouncement />} />
      <CappedContent>
        <FeedColumns>
          <FeedMain>
            <ErrorBoundary fallback={<></>}>
              <ActivityFeed />
            </ErrorBoundary>
          </FeedMain>
          <FeedAside>
            {/* PerformanceWidget: commented out — backend has no me.stats
                or day-bucketed view/like history to power it yet. */}
            {/* <ErrorBoundary fallback={<></>}>
              <PerformanceWidget />
            </ErrorBoundary> */}
            <ErrorBoundary fallback={<></>}>
              <FriendsLeaderboardWidget />
            </ErrorBoundary>
            <ErrorBoundary fallback={<></>}>
              <RecentCompetitionWidget />
            </ErrorBoundary>
            <ErrorBoundary fallback={<></>}>
              <TrendingNowWidget />
            </ErrorBoundary>
            <ErrorBoundary fallback={<></>}>
              <WhoToFollowWidget />
            </ErrorBoundary>
          </FeedAside>
        </FeedColumns>
      </CappedContent>
    </HomepageContainer>
  </HomepageWrapper>
);
